import { useEffect, useState } from "react";
import { Input, PillContainer } from "@salesforce/design-system-react";

import { AllowedDomain, ListResponse, Video } from "vimeo";

import { client as vimeoClient } from "../vimeoClient";

interface Option {
    id: string;
    title: string;
    label: string;
}

interface Props {
    video: Video;
}

export function AllowedDomains(props: Props) {
    const { video } = props;
    const [options, setOptions] = useState<Option[]>([]);
    const videoUri = video.uri.replace("/", "");

    async function getAllowedEmbedDomains() {
        const resp = await vimeoClient.get<ListResponse<AllowedDomain>>(
            `/api/vimeo/${videoUri}/privacy/domains`
        );

        setOptions(
            resp.data.data.map((d) => ({
                id: d.uri,
                title: d.domain,
                label: d.domain,
            }))
        );
    }

    useEffect(() => {
        if (!videoUri) {
            return;
        }

        getAllowedEmbedDomains().catch(console.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function onRemoveDomain(event: Event, data: any) {
        const option = data.option as Option;
        await vimeoClient.delete(`/api/vimeo/${option.id}`);
        setOptions(options?.filter((o) => o.id === option.id));
    }

    async function onSubmitNewDomain(event: KeyboardEvent) {
        if (event.key !== "Enter") {
            return;
        }

        const input = event.target as HTMLInputElement;
        await vimeoClient.put(
            `/api/vimeo/${videoUri}/privacy/domains/${input.value}`
        );
        await getAllowedEmbedDomains();
        input.value = "";
    }

    return (
        <div>
            <Input
                onKeyUp={onSubmitNewDomain}
                type="text"
                placeholder="Type domain then hit enter"
            />
            <div className="slds-var-m-top_small">
                <PillContainer
                    options={options}
                    onRequestRemovePill={onRemoveDomain}
                />
            </div>
        </div>
    );
}
